import { useState, useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import _ from "lodash";

import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CancelIcon from '@mui/icons-material/Cancel';
import { makeStyles } from '@mui/styles';

import { constants } from '../../Constants/constants';
import { post } from "../../helper/baseFetch";
import { setAdminDevice, setAdminDeviceValue } from "../../actions/adminDeviceAction";
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay';
import { TempTextInput } from "../../Component/Input/TempTextInput";
import { TempAutoSelectInput } from "../../Component/Input/TempAutoSelectInput";
import { GlobalDialog } from "../../Component/GlobalDialog";
import AdminDeviceValidation from "../../validations/adminDeviceValidation";
import { adminDeviceValidationConstants } from '../../Constants/validationConstants';
import useRestaurant from "../../hooks/Restaurant/useRestaurant";

const helperTextStyles = makeStyles(theme => ({
  root: {
    color: "red !important",
  },
}));

export const AdminDeviceCreate = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const history = useHistory();
  const params = useParams();
  const [clear, setClear] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: []
  });
  const resource = "AdminDevice";
  const savedAdminDevice = useSelector(state => state.adminDevice.ui.adminDevice);
  const helperTextStylesClasses = helperTextStyles();
  const [, setErrorVersion] = useState(AdminDeviceValidation.getVersion());

  const tabs = [
    {
      label: { resource: resource, key: "info" },
      tabIndex: constants.ADMIN_DEVICE_EDIT_TAB.INFO
    }
  ]

  const tempAdminDeviceEditList = [
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "deviceType" },
      value: savedAdminDevice.deviceType,
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.ADMIN_DEVICE.DEVICE_TYPE,
      name: "deviceType",
      isEndOfLine: false,
      required: true,
      helperTextIcon: true,
      helperText: AdminDeviceValidation.getErrorMessages(adminDeviceValidationConstants.KEY_DEVICE_TYPE),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: "edit-create-input",
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: "activationCode" },
      value: savedAdminDevice.activationCode,
      name: "activationCode",
      isEndOfLine: true,
      required: true,
      helperTextIcon: true,
      helperText: AdminDeviceValidation.getErrorMessages(adminDeviceValidationConstants.KEY_ACTIVATION_CODE),
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
  ]
  const content = [
    {
      tab:
        <>
          {AdminDeviceValidation.getErrorMessages(adminDeviceValidationConstants.KEY_REST_URL_ID) &&
            AdminDeviceValidation.getErrorMessages(adminDeviceValidationConstants.KEY_REST_URL_ID).length > 0 &&
            <div className="error-message">
              <CancelIcon className="error-message-icon" fontSize={constants.SIZE.SMALL} />
              {AdminDeviceValidation.getErrorMessages(adminDeviceValidationConstants.KEY_REST_URL_ID)}
            </div>
          }
          {tempAdminDeviceEditList.map((inputSetting, index) => {
            let content;
            switch (inputSetting.type) {
              case constants.TYPE.SELECT:
                content =
                  <TempAutoSelectInput inputSetting={inputSetting} handleChange={onChangeInput} />
                break;
              default:
                content =
                  <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} />
            }
            return <div className="edit-display-wrapper" key={index}>
              {content}
              {inputSetting.isEndOfLine && <div></div>}
            </div>
          })}
        </>,
      btn: true
    }
  ]
  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "save" },
      onClick: onClickSave,
      className: "margin-left-16",
      icon: <SaveIcon />
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: "clear" },
      disabled: false,
      onClick: onClickClear,
      className: "margin-left-16",
      icon: <ClearIcon />
    }
  ]

  const onClickBackToCreate = () => {
    setDialog({
      open: false,
      dialogActions: []
    });
    onClickClear();
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: []
    })
    history.push("/" + constants.PATH.SHOP.SYSTEM_GROUP_RESTAURANT + "/" + params.restUrlId + "/" + constants.RESTAURANT_TAB.INFO + "/" + constants.RESTAURANT_SUB_TAB.ADMIN_DEVICE);
  };

  function onChangeInput(name, e) {
    dispatch(setAdminDeviceValue(name, savedAdminDevice, "", e));
  }

  function onClickSave() {
    AdminDeviceValidation.validateCreateAdminDevice(savedAdminDevice);
    if (AdminDeviceValidation.isValid()) {
      let tempSavedAdminDevice = _.cloneDeep(savedAdminDevice);
      post(constants.PATH.SHOP.ADMIN_DEVICE, tempSavedAdminDevice, (payload) => {
        setDialog({
          open: true,
          onClose: onClickBackToCreate,
          dialogContentText: { key: "createSuccess" },
          dialogActions: [
            { label: { key: "backCreate" }, onClick: onClickBackToCreate, icon: <ArrowBackIcon /> },
            { label: { key: "backList" }, onClick: onClickBackToList, icon: <LowPriorityIcon /> }
          ]
        })
        setClear(false)
      }, undefined, store);
      AdminDeviceValidation.resetErrorMessages();
    } else {
      setErrorVersion(AdminDeviceValidation.getVersion());
    }
  }

  function onClickClear() {
    setClear(true)
  }

  useEffect(() => {
    AdminDeviceValidation.resetErrorMessages();
    let tempAdminDevice = _.cloneDeep(constants.ADMIN_DEVICE_CREATE_INPUT);
    tempAdminDevice.restUrlId = params.restUrlId;
    dispatch(setAdminDevice(tempAdminDevice));
    setClear(false)
  }, [clear === true]); // eslint-disable-line react-hooks/exhaustive-deps

  const { getRestaurantIdAndName } = useRestaurant(params.restUrlId)
  const mapCode = getRestaurantIdAndName()

  return (
    <>
      <EditCreateDisplay
        code=""
        resource={resource}
        tabs={tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        mapName={{ resource: "restaurant", key: "restUrlId" }}
        mapCode={mapCode}
        display="create"
      />
      {dialog && dialog.open &&
        <GlobalDialog dialogInfo={dialog} />
      }
    </>
  )
};
